import React from 'react';
import { Route } from 'react-router-dom';

import { APP_ROUTES } from '../shared/config/routes-config';
import DailyAvailabilityContainer from './DailyAvailability';

export const DailyAvailabilityModule = () => (
  <Route
    exact
    path={APP_ROUTES.DAILY_AVAILABILITY_MODULE.PATH}
    component={DailyAvailabilityContainer}
  />
);
